import { connect } from 'react-redux';
import ArtistTopSongsComponent from '../components/ArtistTopSongsComponent';
import {
    fetchArtistTopSongsIfNeeded, playTopSong, pauseTopSong,
} from '../actions/ArtistTopSongsActions';
import { playMediaFromSourceWithMeta, pauseMediaPlayer } from '../../aovivoBar/actions/MediaPlayerActions';

const mapStateToProps = (state) => ({
    // artistName: state.artists.ArtistSingle.dataArtistSingle.artistName,
    artistSlug: state.artists.ArtistSingle.dataArtistSingle.slug,
    listTopSongs: state.artists.ArtistTopSongs.listTopSongs,
    isFetching: state.artists.ArtistTopSongs.isFetching,
    isPlayTopSong: state.artists.ArtistTopSongs.isPlayTopSong,
});

const mapDispatchToProps = (dispatch) => ({
    fetchArtistTopSongsIfNeeded: (artist, limit) => {
        dispatch(fetchArtistTopSongsIfNeeded(artist, limit));
    },
    playTopSong: (previewTopSong, src, meta) => {
        dispatch(playTopSong(previewTopSong));

        dispatch(playMediaFromSourceWithMeta({ src, type: 'audio/mp3' }, meta));
    },
    pauseTopSong: () => {
        dispatch(pauseTopSong());

        dispatch(pauseMediaPlayer());
    },
});

const ArtistTopSongsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ArtistTopSongsComponent);

export default ArtistTopSongsContainer;
